import React from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import { Alert } from '../../services/notiflix.service';
import { useState, useEffect } from 'react';
import TransactionService from '../../services/transaction.service';
import moment from 'moment';
import 'react-loading-skeleton/dist/skeleton.css';
import 'react-tooltip/dist/react-tooltip.css';
import {
  CircleRunningIcon,
  DownloadIcon,
} from '../../components/common/IconProvider';
import { formatDate } from '../../utils/Helper';
import DataNotFound from '../../components/common/DataNotFound';
import TableComponent from '../../components/common/TableComponent';
import SortByFilter from '../../components/common/projectListing/SortByFilter';
import { useTranslation } from 'react-i18next';
const FiatTransactions = () => {
  const [fiatTransactionLists, setFiatTransactionList] = useState([]);
  const [isPdfDownload, setPdfDownload] = useState();
  const [isTabStatus, setTabStatus] = useState(1);
  const [isFiatLoader, setFiatLoader] = useState(false);
  const [isSortingLoader, setSortingLoader] = useState(false);

  const [isPdfDownloadLoader, setPdfDownloadLoader] = useState(false);
  const [taxOverviewList, setTaxOverviewList] = useState([]);
  const [isTaxOverviewPdfDownloadLoader, setTaxOverviewPdfDownloadLoader] =
    useState(false);
  const [isOnChainLoader, setOnChainLoader] = useState(false);
  const [isPagination, setPagination] = useState({
    totalPages: 10,
    currentPage: 1,
  });
  const [sortBy, setSortBy] = useState('');
  const { t } = useTranslation(['transactions', 'common']);
  const [isOnChangeHeaderList, setOnChangeHeaderList] = useState([]);
  useEffect(() => {
    setOnChangeHeaderList([
      { Name: t('common:issue') },
      { Name: t('transaction') },
      { Name: t('common:from') },
      { Name: t('common:to') },
      { Name: 'TOKENS' },
      { Name: t('common:created') },
      { Name: 'STATUS' },
    ]);
  }, [t]);
  const [isFiatHeaderList, setFiatHeaderList] = useState([]);
  useEffect(() => {
    setFiatHeaderList([
      { Name: t('common:issue') },
      { Name: t('common:type') },
      { Name: t('common:transaction_id') },
      { Name: t('qty') },
      { Name: t('common:amount') },
      { Name: t('common:created') },
      { Name: t('common:payment_method') },
      { Name: 'STATUS' },
      { Name: t('common:action') },
    ]);
  }, [t]);
  const [isTab1List, setIsTab1List] = useState([]);
  useEffect(() => {
    setIsTab1List([
      {
        name: t('common:all'),
        value: '',
      },
      {
        name: t('common:created'),
        value: 'created',
      },
      {
        name: t('common:pending'),
        value: 'pending',
      },
      {
        name: t('common:completed'),
        value: 'completed',
      },
      {
        name: t('common:failure'),
        value: 'failed',
      },
    ]);
  }, [t]);

  const [isTab2List, setIsTab2List] = useState([]);
  useEffect(() => {
    setIsTab2List([
      {
        name: t('common:sort_by'),
        value: '',
      },
      {
        name: 'PURCHASE',
        value: 'purchase',
      },
      {
        name: 'TRANSFER',
        value: 'transfer',
      },
    ]);
  }, [t]);

  const [onChainTransactionLists, setOnChainTransactionList] = useState([]);
  const [filterFiatData, setFilterFiatData] = useState({
    perPage: 10,
    page: 1,
    commonSearch: '',
    date: '',
    type: '',
    status: '',
  });
  const [filterOnChainData, setFilterOnChainData] = useState({
    perPage: 10,
    page: 1,
    commonSearch: '',
    sortBy: '',
    project_id: '',
    type: '',
  });
  const fiatTransactionList = async (
    pagination = { currentPage: 1 },
    sorting = { field: '', order: '' },
    isSorting = false,
  ) => {
    try {
      if (isSorting) {
        setSortingLoader(true); // Show sorting loader
      } else {
        setFiatLoader(true); // Show pagination loader
      }
      const { currentPage } = pagination;
      const { field, order } = sorting;
      let projectListRes = await TransactionService.fiatList(
        filterFiatData.perPage,
        currentPage,
        filterFiatData.commonSearch,
        filterFiatData.date,
        filterFiatData.type,
        filterFiatData.status,
        field,
        order,
      );
      if (projectListRes.status === 'failure') {
        setFiatLoader(false);
        setSortingLoader(false);
        Alert.error(projectListRes.message);
        return false;
      }
      setFiatLoader(false);
      setSortingLoader(false);
      setFiatTransactionList(projectListRes.data.records);
      setPdfDownload(projectListRes.data.isDownloadTransactionPdf);

      if (isTabStatus === 1) {
        setPagination({
          totalPages: projectListRes.data.pagination.totalPages,
          currentPage: projectListRes.data.pagination.page,
        });
      }
    } catch (error) {
      setFiatLoader(false);
      setSortingLoader(false);
      Alert.error(error.message);
      return false;
    }
  };

  const onChainTransactionList = async (
    pagination = { currentPage: 1 },
    sorting = { field: '', order: '' },
    isSorting = false,
  ) => {
    try {
      if (isSorting) {
        setSortingLoader(true); // Show sorting loader
      } else {
        setOnChainLoader(true); // Show pagination loader
      }
      const { currentPage } = pagination;
      const { field, order } = sorting;
      let projectListRes = await TransactionService.onChainList(
        filterOnChainData.perPage,
        // filterOnChainData.page,
        currentPage,
        filterOnChainData.commonSearch,
        filterOnChainData.sortBy,
        filterOnChainData.project_id,
        filterOnChainData.type,
        field,
        order,
      );
      if (projectListRes.status === 'failure') {
        setOnChainLoader(false);
        setSortingLoader(false);
        Alert.error(projectListRes.message);
        return false;
      }
      setOnChainLoader(false);
      setSortingLoader(false);
      setOnChainTransactionList(projectListRes.data.records);

      if (isTabStatus !== 1) {
        setPagination({
          totalPages: projectListRes.data.pagination.totalPages,
          currentPage: projectListRes.data.pagination.page,
        });
      }
    } catch (error) {
      setOnChainLoader(false);
      setSortingLoader(false);
      Alert.error(error.message);
      return false;
    }
  };

  useEffect(() => {
    getTaxOverviewList();
  }, []);

  useEffect(() => {
    setOnChainLoader(true);
    setFiatLoader(true);
    fiatTransactionList();
    onChainTransactionList();
  }, [filterFiatData, filterOnChainData]);
  const tabSwitch = async (_type) => {
    if (_type === 1) {
      setTabStatus(1);
      setFiatLoader(true);
      setFilterFiatData({
        ...filterFiatData,
        page: 1,
      });
      await fiatTransactionList();
    } else {
      setTabStatus(2);
      setOnChainLoader(true);
      setFilterOnChainData({
        ...filterOnChainData,
        page: 1,
      });
      await onChainTransactionList();
    }
  };
  const searchData = async (slug, _action) => {
    setSortBy(_action);
    if (isTabStatus === 1) {
      setTabStatus(1);
      setFiatLoader(true);
      setFilterFiatData({
        ...filterFiatData,
        page: 1,
        status: _action,
      });
    } else {
      setTabStatus(2);
      setOnChainLoader(true);
      setFilterOnChainData({
        ...filterOnChainData,
        page: 1,
        type: _action,
      });
    }
  };

  const downloadPDF = async () => {
    setPdfDownloadLoader(true);
    try {
      let projectListRes = await TransactionService.downloadPDF();
      if (projectListRes.status === 'failure') {
        setPdfDownloadLoader(false);
        Alert.error(projectListRes.message);
        return false;
      }

      const numbers = projectListRes.data.data
        .toString()
        .split(',')
        .map(Number);
      const htmlContent = String.fromCharCode(...numbers);

      var opt = {
        margin: 2,
        html2canvas: { scale: 3 },
        jsPDF: { unit: 'mm', format: 'a4' },
      };
      // lazy load the html2pdf library
      const module = await import('html2pdf.js');
      const html2pdf = module.default;
      const pdfBlob = await html2pdf()
        .set(opt)
        .from(htmlContent)
        .outputPdf('blob');

      // Create a Blob URL and initiate download
      const fileURL = URL.createObjectURL(pdfBlob);

      const anchor = document.createElement('a');
      anchor.href = fileURL;
      anchor.download =
        'Transactions-' + formatDate(moment(), 'MM-DD-YYYY') + '.pdf';
      anchor.style.display = 'none';

      document.body.appendChild(anchor);
      anchor.click();

      // Clean up
      URL.revokeObjectURL(fileURL);
      document.body.removeChild(anchor);
      setPdfDownloadLoader(false);
    } catch (error) {
      setPdfDownloadLoader(false);
      Alert.error(error);
      return false;
    }
  };

  //Download pdf for tax overview
  const downloadTaxOverviewPDF = async () => {
    setTaxOverviewPdfDownloadLoader(true);
    try {
      let projectListRes = await TransactionService.downloadTaxOverviewPDF();
      if (projectListRes.status === 'failure') {
        setTaxOverviewPdfDownloadLoader(false);
        Alert.error(projectListRes.message);
        return false;
      }

      const numbers = projectListRes.data.data
        .toString()
        .split(',')
        .map(Number);
      var opt = {
        margin: 3,
        html2canvas: { scale: 2 },
        jsPDF: { unit: 'mm', format: 'a4' },
      };
      const htmlContent = String.fromCharCode(...numbers);

      // lazy load the html2pdf library
      const module = await import('html2pdf.js');
      const html2pdf = module.default;
      const pdfBlob = await html2pdf()
        .set(opt)
        .from(htmlContent)
        .outputPdf('blob');

      // Create a Blob URL and initiate download
      const fileURL = URL.createObjectURL(pdfBlob);

      const anchor = document.createElement('a');

      anchor.href = fileURL;
      anchor.download =
        'Tax_Overview-' + formatDate(moment(), 'MM-DD-YYYY') + '.pdf';
      anchor.style.display = 'none';

      document.body.appendChild(anchor);
      anchor.click();

      // Clean up
      URL.revokeObjectURL(fileURL);
      document.body.removeChild(anchor);
      setTaxOverviewPdfDownloadLoader(false);
    } catch (error) {
      setTaxOverviewPdfDownloadLoader(false);
      Alert.error(error);
      return false;
    }
  };

  const getTaxOverviewList = async () => {
    try {
      let taxOverviewListResp = await TransactionService.getTaxOverviewList();
      setTaxOverviewList(taxOverviewListResp?.data?.data);
    } catch (error) {
      Alert.error(error);
      return false;
    }
  };

  return (
    <>
      <div className="md:pb-5 md:pl-5">
        <div className=" text-center my-24">
          <h2 className="dark:text-white">{t('transaction_history')}</h2>
          <p className="mt-2 dark:text-white">{t('transaction_details')}</p>
        </div>
        <div className="bg-[#F3F3F3] md:dark:bg-slate-800 md:dark:text-slate-200 p-4 rounded-md">
          <div>
            <Tabs>
              <div className="md:flex items-center justify-between gap-2 pb-2 border-b border-[#B6BDC5]">
                <TabList className="flex md:mb-0 mb-4">
                  <Tab onClick={() => tabSwitch(1)} className="rounded-button">
                    {t('fiat_transaction')}{' '}
                  </Tab>
                  <Tab onClick={() => tabSwitch(2)} className="rounded-button">
                    {t('on_chain_transaction')}
                  </Tab>
                </TabList>
                <div className="flex items-center gap-2">
                  <div className="mr-2 md:inline-block hidden">
                    {t('filter_by')}
                  </div>
                  <SortByFilter
                    searchData={searchData}
                    dropdownList={isTabStatus === 1 ? isTab1List : isTab2List}
                    value={sortBy}
                  />
                  <div className=""></div>
                  {isTabStatus === 1 &&
                    fiatTransactionLists &&
                    fiatTransactionLists?.length > 0 && (
                      <div className="flex  font-semibold text-md">
                        <button
                          onClick={() => downloadPDF()}
                          disabled={
                            isPdfDownloadLoader || !isPdfDownload ? true : false
                          }
                          className={`border border-gray-300 px-4 py-2.5 bg-white rounded-md text-[#0B243F] flex ${
                            !isPdfDownload
                              ? 'cursor-not-allowed bg-gray-300'
                              : ''
                          }`}
                        >
                          <span className="text-sm font-medium">
                            {' '}
                            {isPdfDownloadLoader ? (
                              <div className="flex items-center gap-2">
                                <CircleRunningIcon />
                                {t('downloading')}
                              </div>
                            ) : (
                              <div className="flex items-center gap-2">
                                <DownloadIcon />
                                {t('download_pdf')}
                              </div>
                            )}
                          </span>
                        </button>
                      </div>
                    )}
                  {(isTabStatus === 1 && taxOverviewList) ||
                  (isTabStatus === 2 && taxOverviewList) ? (
                    <div className="flex justify-end mr-4">
                      <button
                        onClick={() => downloadTaxOverviewPDF()}
                        disabled={isTaxOverviewPdfDownloadLoader ? true : false}
                        className="border border-gray-300 px-4 py-2.5 bg-white rounded-md text-[#0B243F]  flex"
                      >
                        <span className="text-sm font-medium">
                          {' '}
                          {isTaxOverviewPdfDownloadLoader ? (
                            <div className="flex items-center gap-2">
                              <CircleRunningIcon />
                              {t('downloading')}
                            </div>
                          ) : (
                            <div className="flex items-center gap-2">
                              <DownloadIcon />
                              {/* Download Tax OVerview PDF */}
                              {t('download_tax_overview')}
                            </div>
                          )}
                        </span>
                      </button>
                    </div>
                  ) : null}
                </div>
              </div>

              <TabPanel>
                <div className="relative overflow-x-auto  sm:rounded-lg">
                  <TableComponent
                    headerList={isFiatHeaderList}
                    isListLoader={isFiatLoader}
                    isSortingLoader={isSortingLoader}
                    isList={fiatTransactionLists}
                    columnCount={10}
                    fetchData={fiatTransactionList}
                    pagination={isPagination}
                    setPagination={setPagination}
                    filterData={filterFiatData}
                    rowCount={6}
                    slug={'isFiatList'}
                  />
                </div>
                {fiatTransactionLists &&
                  fiatTransactionLists?.length === 0 &&
                  isFiatLoader === false && (
                    <DataNotFound
                      message={t('haven’t_performed_transaction_yet')}
                      link={true}
                    />
                  )}
              </TabPanel>
              <TabPanel>
                <div className="relative overflow-x-auto  sm:rounded-lg">
                  <TableComponent
                    headerList={isOnChangeHeaderList}
                    isListLoader={isOnChainLoader}
                    isSortingLoader={isSortingLoader}
                    isList={onChainTransactionLists}
                    fetchData={onChainTransactionList}
                    pagination={isPagination}
                    setPagination={setPagination}
                    filterData={filterOnChainData}
                    columnCount={9}
                    rowCount={6}
                    slug={'onChainList'}
                  />
                  {onChainTransactionLists &&
                    onChainTransactionLists?.length === 0 &&
                    isOnChainLoader === false && (
                      <DataNotFound
                        message={t('haven’t_performed_transaction_yet')}
                        link={true}
                      />
                    )}
                </div>
              </TabPanel>
            </Tabs>
          </div>
        </div>
      </div>
    </>
  );
};

export default FiatTransactions;
